import * as Types from './actionTypes';

export const newNotification = (payload) => ({
  type: Types.NEW_NOTIFICATION,
  payload,
});

export const newToken = (token) => ({
  type: Types.NEW_TOKEN,
  payload: {
    token,
  },
});
export const clearNotifications = () => ({
  type: Types.CLEAR_NOTIFICATIONS,
});

export const markAsClosed = (id) => ({
  type: Types.MARK_AS_CLOSED,
  payload: {
    id,
  },
});

export const markAsEntered = (id) => ({
  type: Types.MARK_AS_ENTERED,
  payload: {
    id,
  },
});
